import { LocationStoreProvider } from '@/components/tabs/location-store-context';
import { Region } from '@/components/region';
import { SeoMeta } from '@/components/seo-meta';
import { readPageLocationName } from '@/lib/page-location';
import type { PageDesignerRouteData } from './types';

export function PageDesignerRoute({ data }: { data: PageDesignerRouteData }) {
    const title = data.page.name || data.pageId;
    const description = data.page.description;
    const locationName = readPageLocationName(data.page) ?? null;
    const parentLocationLabel = data.parentLocationLabel ?? null;

    return (
        <>
            <SeoMeta
                pageTitle={data.page.pageTitle}
                pageDescription={data.page.pageDescription}
                title={title}
                description={description || undefined}
                openGraph={{
                    type: 'website',
                    url: data.pageUrl,
                }}
            />
            <LocationStoreProvider store={null} locationName={locationName} parentLocationLabel={parentLocationLabel}>
                {data.page.regions?.map((region) => (
                    <Region key={`${data.page.id}:${region.id}`} page={data.page} regionId={region.id} />
                ))}
            </LocationStoreProvider>
        </>
    );
}
